//假设这里定义用户功能模块的api请求

//一般根据具体的接口服务模块约定
const baseURL = '/api';
const publicUrl = '/public';
import listRequest from '../../js/listRequest.js';
import basicRequest from '@/js/basicRequest.js';
const handleFn = (data: any, parameters: any, fn: any) => {
    if (fn != undefined && typeof fn == 'function') {
        fn(data, parameters);
    }
};

export const userApi = {
    //最简单的写法，列表啥也不用做
    getList(opt: any, pageData?: any) {
        var servicesPath = baseURL + '/v1/user/list';
        let context = opt.context;
        listRequest.request({
            url: servicesPath,
            context: context,
            isShowLoading: false,
            urlQueryParmas: opt.urlQueryParmas || {},
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },
    saveRecord(opt: any) {
        var servicesPath = baseURL + '/v1/user';
        let context = opt.context;
        let pageData = opt.data || {};
        // console.log(pageData);

        let ajaxType = 'POST';
        if (pageData._id != undefined && pageData._id != '') {
            ajaxType = 'PUT';
            servicesPath += '/' + pageData._id;
            delete pageData._id;
        }
        basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '保存中，请稍等...',
            ajaxOpt: {
                //ajax的参数配置
                type: ajaxType //HTTP请求类型
            },
            data: pageData,
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },
    deleteRecord(opt: any) {
        var servicesPath = baseURL + '/v1/user';

        let context = opt.context;
        let pageData = opt.data || {};
        let urlParamObj = opt.urlParamObj || {};
        servicesPath += '/' + urlParamObj.id;

        basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '请稍等...',
            ajaxOpt: {
                //ajax的参数配置
                type: 'DELETE' //HTTP请求类型
            },
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },
    getRecord(opt: any) {
        var servicesPath = baseURL + '/v1/user';

        let context = opt.context;
        let urlParamObj = opt.urlParamObj || {};
        servicesPath += '/' + urlParamObj.id;

        basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '请稍等...',
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET' //HTTP请求类型
            },
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },
    login(opt: any) {
        var servicesPath = baseURL + '/v1/user/login';
        let context = opt.context;
        basicRequest.request({
            url: servicesPath,
            context: context,
            /*headers:{ //设置请求的默认 header
				"content-type":"application/json"
			},*/
            waitingtip: '正在登录中......',
            needLogin: false,
            data: opt.data,
            success: function (data: any, parameters: any) {
                // console.log('登录信息：' + JSON.stringify(data.content));
                if (opt.success) {
                    opt.success(data.data, parameters);
                }
            },
            error: function (data: any, message: string, parameters: any) {
                // console.log('登录失败:' + message);
                if (opt.error) {
                    opt.error(data, message, parameters);
                }
            }
        });
    },
    /**
     * @param {Object} 退出登录
     */
    logout(opt: any) {
        var servicesPath = baseURL + '/v1/user/logout';
        let context = opt.context;

        basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '正在退出登录中......',
            data: {},
            success: function (data: any, parameters: any) {
                // console.log('退出登录信息：' + JSON.stringify(data.content));
                if (opt.success) {
                    opt.success(data, parameters);
                }
            },
            error: function (data: any, message: any, parameters: any) {
                // console.log('退出登录失败:' + message);
                if (opt.error) {
                    opt.error(data, message, parameters);
                }
            }
        });
    },
    /**
     * @param mobile  根据手机号码查询用户
     */
    getUserByMobile(opt: any) {
        var servicesPath = baseURL + '/v1/user';
        let context = opt.context;
        let pageData = opt.data || {};
        let urlParamObj = opt.urlParamObj || {};
        servicesPath += '?mobile=' + opt.mobile;
        basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '加载数据中，请稍等...',
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET' //HTTP请求类型
            },
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            }
        });
    },
    /**
     * @param mobile,newPwd，code  重置用户密码
     */
    resetUserPwd(opt: any) {
        var servicesPath = baseURL + '/v1/user/password/msg';
        let context = opt.context;
        let smsdata = opt.data || {};
        basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '密码重置中，请稍等...',
            ajaxOpt: {
                //ajax的参数配置
                type: 'PUT' //HTTP请求类型
            },
            data: smsdata,
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error: function (data: any, message: any, parameters: any) {
                // console.log('重置密码失败:' + message);
                if (opt.error) {
                    opt.error(data, message, parameters);
                }
            }
        });
    },

    /**
     * @param username,oldPwd,newPwd,code,captchaKey 修改用户密码
     */
    changeUserPwd(opt: any) {
        var servicesPath = publicUrl + '/v1/user/password/graphicCode';
        let context = opt.context;
        let smsdata = opt.data || {};
        basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '密码重置中，请稍等...',
            ajaxOpt: {
                //ajax的参数配置
                type: 'PATCH' //HTTP请求类型
            },
            data: smsdata,
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error: function (data: any, message: any, parameters: any) {
                // console.log('修改密码失败:' + message);
                if (opt.error) {
                    opt.error(data, message, parameters);
                }
            }
        });
    },

    /**
     * 获取图形验证码
     */
    getGraphicCode(opt: any) {
        var servicesPath = publicUrl + '/v1/user/graphicCode';
        let context = opt.context;
        let smsdata = opt.data || {};
        basicRequest.request({
            url: servicesPath,
            context: context,
            needLogin: false,
            waitingtip: '数据加载中，请稍等...',
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET' //HTTP请求类型
            },
            data: smsdata,
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error: function (data: any, message: any, parameters: any) {
                if (opt.error) {
                    opt.error(data, message, parameters);
                }
            }
        });
    },

    /**
     * @param captchaKey 刷新图形验证码
     */
    refreshGraphicCode(opt: any) {
        var servicesPath = publicUrl + '/v1/user/refresh/graphicCode';
        let context = opt.context;
        let smsdata = opt.data || {};
        let urlParams = opt.urlParams || {};
        basicRequest.request({
            url: servicesPath,
            context: context,
            needLogin: false,
            waitingtip: '数据加载中，请稍等...',
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET' //HTTP请求类型
            },
            urlParams: urlParams,
            data: smsdata,
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error: function (data: any, message: any, parameters: any) {
                if (opt.error) {
                    opt.error(data, message, parameters);
                }
            }
        });
    },
    /** 为跳转普通平台生成用户凭证 http://yapi.dm-ai.cn:3000/project/163/interface/api/7795 */
    getTicket(opt: any) {
        var servicesPath = baseURL + '/v1/user/jump/ticket';
        let context = opt.context;
        context.$basicRequest.request({
            context: context,
            url: servicesPath,
            waitingtip: '加载数据中，请稍等...',
            ajaxOpt: {
                //ajax的参数配置
                type: 'POST' //HTTP请求类型
            },
            data: opt.data,
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            }
        });
    },
    getUserFind(opt?: any) {
        opt = opt || {};
        var url = baseURL + '/v1/user/find';
        basicRequest.request({
            url,
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET' //HTTP请求类型
            },
            urlParams: opt.urlParams,
            success: (data: any, parameters: any) => handleFn(data, parameters, opt.success),
            error: (data: any, parameters: any) => handleFn(data, parameters, opt.error)
        });
    },
    getUserFindExtra(opt?: any) {
        opt = opt || {};
        var url = baseURL + '/v1/user/find/extra';
        basicRequest.request({
            url,
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET' //HTTP请求类型
            },
            urlParams: opt.urlParams,
            success: (data: any, parameters: any) => handleFn(data, parameters, opt.success),
            error: (data: any, parameters: any) => handleFn(data, parameters, opt.error)
        });
    },
    // 获取教师授课班级与课程  http://yapi.dm-ai.cn:3000/project/334/interface/api/4570
    getTeacherClassCourse(opt?: any) {
        var servicesPath = baseURL + '/v1/class/teacher/list';
        let context = opt.context;
        basicRequest.request({
            url: servicesPath,
            context: context,
            isShowLoading: false,
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET' //HTTP请求类型
            },
            urlParams: opt.urlParams,
            success: (data: any, parameters: any) => handleFn(data, parameters, opt.success),
            error: (data: any, parameters: any) => handleFn(data, parameters, opt.error)
        });
    },
    // 获取更换手机号的验证码  http://yapi.dm-ai.cn:3000/project/343/interface/api/3270
    getCode(opt?: any) {
        var servicesPath = baseURL + '/v1/sms/code';
        let context = opt.context;
        basicRequest.request({
            url: servicesPath,
            context: context,
            isShowLoading: false,
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET' //HTTP请求类型
            },
            urlParams: opt.urlParams,
            success: (data: any, parameters: any) => handleFn(data, parameters, opt.success),
            error: (data: any, parameters: any) => handleFn(data, parameters, opt.error)
        });
    },
    // 验证短信验证码及修改手机号  http://yapi.dm-ai.cn:3000/project/163/interface/api/4500
    validateCodeChangePhone(opt?: any) {
        var servicesPath = baseURL + '/v1/user/mobile';
        let context = opt.context;
        let smsdata = opt.data || {};
        basicRequest.request({
            url: servicesPath,
            context: context,
            isShowLoading: false,
            ajaxOpt: {
                //ajax的参数配置
                type: 'PATCH' //HTTP请求类型
            },
            data: smsdata,
            success: (data: any, parameters: any) => handleFn(data, parameters, opt.success),
            error: (data: any, parameters: any) => handleFn(data, parameters, opt.error)
        });
    }
};
